import PropTypes from 'prop-types';

export default PropTypes.shape({
    name: PropTypes.string,
    colors: PropTypes.objectOf(PropTypes.string),
    fontFamily: PropTypes.string,
    texts: PropTypes.objectOf(PropTypes.string),
    files: PropTypes.objectOf(PropTypes.string),
    sections: PropTypes.objectOf(PropTypes.bool),
})